import type { Dictionary } from './en';

export const fr: Dictionary = {
  'app.name': 'hmawiw',
  'app.tagline': 'Votre tableau, selon l’envie que vous avez de faire les choses et l’énergie qu’elles demandent.',
  'nav.board': 'Tableau',
  'nav.journal': 'Journal',
  'nav.settings': 'Réglages',
  'nav.admin': 'Admin',
  'nav.back': 'Retour',
  'nav.columns': 'Colonnes',
  'boards.switch': 'Changer de tableau',
  'boards.manage': 'Gérer les tableaux',
  'boards.onScreen': 'À l’écran',
  'boards.nameOf': 'Nom de {name}',
  'boards.up': 'Monter {name}',
  'boards.down': 'Descendre {name}',
  'boards.removeOne': 'Supprimer {name}',
  'boards.confirmRemoveOne': 'Supprimer {name} ?',
  'boards.shortcut': 'Changer de tableau : Alt avec Haut ou Bas',
  'boards.chip': 'Tableau : {name}. Touchez pour la liste, ou maintenez et glissez vers le haut jusqu’à un tableau.',
  'boards.hint': 'Touchez le nom du tableau pour la liste, ou maintenez-le et glissez vers le haut jusqu’à un tableau.',
  'boards.manageIn': 'Gérer les tableaux dans les Réglages',
  'settings.boards': 'Tableaux',
  'settings.boardsHint': 'Sur le téléphone, les tableaux sont en bas dans cet ordre, à une touche chacun ; quand ils ne tiennent plus, le nom du tableau les liste : touchez-le, ou maintenez-le et glissez vers le haut jusqu’à l’un d’eux. Un tableau avec des cartes ouvertes reste tant qu’elles ne sont ni déplacées ni terminées.',
  'boards.title': 'Tableaux',
  'boards.new': 'Nouveau tableau',
  'boards.namePlaceholder': 'Travail, Maison, Projet perso…',
  'boards.add': 'Ajouter',
  'boards.remove': 'Supprimer',
  'boards.notEmpty': 'Un tableau avec des cartes ouvertes reste ; déplacez-les ou terminez-les d’abord.',
  'sheet.board': 'Tableau',
  'toast.movedToBoard': 'Déplacée vers {board}',
  'column.0': 'Redouté',
  'column.1': 'Neutre',
  'column.2': 'Impatient',
  'column.n': 'Niveau {n}',
  'band.importance.0': 'Doit',
  'band.importance.1': 'Devrait',
  'band.importance.2': 'Pourrait',
  'band.horizon.0': 'Aujourd’hui',
  'band.horizon.1': 'Cette semaine',
  'band.horizon.2': 'Un jour',
  'energy.1': 'Faible',
  'energy.2': 'Moyenne',
  'energy.3': 'Haute',
  'lens.label': 'Mon énergie',
  'lens.cycle': 'Mon énergie : {level}. Touchez pour changer.',
  'lens.none': 'non définie',
  'lens.hint': 'Les cartes qui en demandent plus s’estompent. Elle s’efface d’elle-même après six heures.',
  'lens.clear': 'Effacer',
  'count.cards.one': '1 carte',
  'count.cards.other': '{n} cartes',
  'count.boards.one': '1 tableau',
  'count.boards.other': '{n} tableaux',
  'card.energyAria': 'Demande une énergie {level}. Touchez pour changer.',
  'card.open': 'Ouvrir la carte',
  'card.grip': 'Maintenez pour déplacer dans la colonne',
  'due.today': 'Aujourd’hui',
  'due.tomorrow': 'Demain',
  'due.inDays': 'Dans {n} jours',
  'due.on': '{date}',
  'due.late.one': '1 jour de retard',
  'due.late.other': '{n} jours de retard',
  'due.lateToday': 'Dépassée',
  'tag.editedElsewhere': 'Modifié ailleurs',
  'sheet.title': 'Titre',
  'sheet.notes': 'Notes',
  'sheet.firstStep': 'Premier pas',
  'sheet.firstStepHint': 'La version en cinq minutes',
  'sheet.sectionStep': 'Premier pas & 10 minutes',
  'sheet.sectionPlan': 'Échéance, répétition & rappels',
  'timer.start': 'Accorde-lui 10 minutes',
  'timer.stop': 'Arrêter',
  'timer.left': '{time} restantes',
  'timer.up': '10 minutes écoulées : {title}',
  'timer.open': 'Ouvrir',
  'timer.dismiss': 'Fermer',
  'timer.tried.one': 'Tenté une fois',
  'timer.tried.other': 'Tenté {n} fois',
  'timer.last': 'dernière {when}',
  'feel.title': 'Et maintenant, ça donne quoi ?',
  'feel.worse': 'Pire',
  'feel.same': 'Pareil',
  'feel.better': 'Mieux',
  'card.attempts.one': '1 tentative',
  'card.attempts.other': '{n} tentatives',
  'notif.timerTitle': '10 minutes écoulées',
  'notif.alarmChannel': 'Alarmes',
  'notif.alarmChannelHint': 'Rappels et minuteurs réglés pour sonner',
  'reminder.ringOff': 'Notification. Touchez pour sonner comme une alarme.',
  'reminder.ringOn': 'Alarme. Touchez pour notifier en silence.',
  'reminder.ringHint': 'La cloche notifie ; le réveil sonne et vibre.',
  'settings.timerAlert': 'Fin des 10 minutes',
  'settings.timerAlertHint': 'Comment la fin d’une tentative est annoncée.',
  'settings.alert.notify': 'Notification',
  'settings.alert.ring': 'Alarme',
  'sheet.motivation': 'Motivation',
  'sheet.less': 'Moins motivé',
  'sheet.more': 'Plus motivé',
  'sheet.importance': 'Bande',
  'sheet.energy': 'Énergie nécessaire',
  'sheet.reminders': 'Rappels',
  'sheet.addReminder': 'Ajouter un rappel…',
  'sheet.reminderHint': 'Les rappels sonnent sur le téléphone.',
  'reminder.atDue': 'À l’échéance',
  'reminder.before.1h': '1 heure avant',
  'reminder.before.1d': '1 jour avant',
  'reminder.before.1w': '1 semaine avant',
  'reminder.before.other': '{hours} heures avant',
  'reminder.custom': 'À une heure de mon choix…',
  'reminder.add': 'Ajouter',
  'reminder.remove': 'Retirer ce rappel',
  'reminder.needsDue': 'Les rappels relatifs à l’échéance demandent une date d’échéance.',
  'reminder.noDue': 'pas encore d’échéance',
  'card.reminders': '{n} rappels',
  'notif.checkinTitle': 'Comment va votre énergie aujourd’hui ?',
  'notif.checkinBody': 'Réglez-la et le tableau estompe ce que vous ne pouvez pas affronter.',
  'notif.digestBack': 'De retour aujourd’hui :',
  'notif.digestQuiet': 'Restées silencieuses :',
  'notif.digestMore': 'et {n} de plus',
  'sheet.due': 'Échéance',
  'sheet.clearDue': 'Effacer l’échéance',
  'sheet.done': 'Terminé',
  'sheet.delete': 'Supprimer',
  'sheet.close': 'Fermer',
  'sheet.cancel': 'Annuler',
  'sheet.markDone': 'Terminé',
  'sheet.confirmDelete': 'Supprimer cette carte ?',
  'sheet.keep': 'Garder',
  'sheet.dueTime': 'Heure',
  'sheet.repeat': 'Répétition',
  'repeat.never': 'Ne se répète pas',
  'repeat.after': 'Jours après terminé',
  'repeat.weekly': 'Chaque semaine',
  'repeat.monthly': 'Chaque mois',
  'repeat.yearly': 'Chaque année',
  'repeat.ongoing': 'Continu, jamais terminé',
  'repeat.afterDays': 'jours après l’avoir terminée',
  'repeat.afterDaysAria': 'Jours après terminé',
  'repeat.monthDay': 'Jour du mois',
  'repeat.month': 'Mois',
  'repeat.rhythm': 'Viser tous les',
  'repeat.rhythmAria': 'Jours entre deux fois',
  'repeat.daysUnit': 'jours',
  'repeat.weekdays': 'Jours de la semaine',
  'repeat.lead': 'Réapparaît',
  'repeat.lead.0': 'le jour même',
  'repeat.lead.1': '1 jour avant',
  'repeat.lead.2': '2 jours avant',
  'repeat.lead.3': '3 jours avant',
  'repeat.lead.7': '1 semaine avant',
  'repeat.lead.14': '2 semaines avant',
  'repeat.lead.30': '1 mois avant',
  'repeat.resting': 'En repos jusqu’au {date}.',
  'repeat.wake': 'Ramener maintenant',
  'repeat.doneCount.one': 'Terminée une fois',
  'repeat.doneCount.other': 'Terminée {n} fois',
  'repeat.touchedCount.one': 'Touchée une fois',
  'repeat.touchedCount.other': 'Touchée {n} fois',
  'repeat.hint': 'Terminé garde la carte et avance sa date ; entre deux dates elle se repose hors du tableau.',
  'repeat.ongoingHint': 'Pas de Terminé : touchez quand vous y avez consacré du temps. Passé le rythme, elle passe au rouge et rejoint la revue.',
  'sheet.markDoneNext': 'Terminé pour cette fois',
  'sheet.touch': 'J’y ai consacré du temps',
  'dread.why': 'Pourquoi redoutée ?',
  'dread.unclear': 'Floue',
  'dread.big': 'Trop grosse',
  'dread.boring': 'Ennuyeuse',
  'dread.scary': 'Effrayante',
  'dread.waiting': 'En attente de quelqu’un',
  'dread.unclear.move': 'Écrivez ce que seraient les cinq premières minutes.',
  'dread.unclear.action': 'Écrire le premier pas',
  'dread.big.move': 'Seul le premier pas doit exister aujourd’hui.',
  'dread.big.action': 'Écrire le premier pas',
  'dread.boring.move': 'Dix minutes chrono, le chemin le moins cher à travers l’ennui.',
  'dread.boring.action': 'Lui donner 10 minutes',
  'dread.scary.move': 'Dix minutes, puis décidez de ce que ça fait.',
  'dread.scary.action': 'Lui donner 10 minutes',
  'dread.waiting.move': 'Posez un rappel pour relancer, et cessez de la porter.',
  'dread.waiting.action': 'Ajouter un rappel',
  'moment.lead': 'Vous avez de l’énergie : le moment pour une redoutée.',
  'moment.open': 'Ouvrir',
  'moment.later': 'Pas maintenant',
  'pinned.lead': 'Votre chose redoutée du jour',
  'pinned.unpin': 'Détacher',
  'checkin.title': 'Point du matin',
  'checkin.energy': 'Comment va votre énergie ?',
  'checkin.pick': 'Une chose redoutée pour aujourd’hui ?',
  'checkin.none': 'Rien dans Redoutée. Profitez-en.',
  'checkin.notToday': 'Pas aujourd’hui',
  'card.repeats': 'Se répète',
  'card.last': 'Dernière fois {when}',
  'toast.next': 'Terminé. Prochaine : {date}',
  'toast.touched': 'Noté : {title}',
  'lists.resting': 'En repos',
  'resting.hint': 'Les cartes récurrentes entre deux dates. Chacune revient d’elle-même, peu avant son échéance.',
  'resting.empty': 'Rien en repos.',
  'resting.returns': 'Revient {date}',
  'review.quiet': 'Continues, restées silencieuses',
  'conflict.editedOn': 'Modifié sur {device} pendant que vous étiez hors ligne.',
  'conflict.editedElsewhere': 'Modifié sur un autre appareil pendant que vous étiez hors ligne.',
  'conflict.theirs': 'Leur valeur : {value}',
  'conflict.useTheirs': 'Prendre la leur',
  'conflict.keepMine': 'Garder la mienne',
  'add.title': 'Nouvelle carte',
  'add.placeholder': 'De quoi s’agit-il ?',
  'add.column': 'Colonne',
  'add.submit': 'Ajouter à {column}',
  'add.cancel': 'Annuler',
  'add.toBand': 'Ajouter une carte dans {column}, {band}',
  'add.shared': 'Partagé depuis une autre application',
  'add.inbox': 'Trier plus tard',
  'add.toInbox': 'Ajouter à la boîte',
  'inbox.title': 'Boîte de réception',
  'inbox.count': 'Boîte · {n}',
  'inbox.sort': 'Trier',
  'inbox.hint': 'Ajoutées en passant. Donnez une colonne à chacune ; la bande et l’énergie attendront la carte.',
  'done.empty': 'Rien de terminé pour l’instant. Ouvrez une carte et touchez Terminé.',
  'done.restore': 'Restaurer',
  'lists.done': 'Terminé',
  'lists.deleted': 'Supprimées',
  'lists.review': 'Revue',
  'lists.stats': 'Stats',
  'stats.hint': 'Calculées sur cet appareil à partir de vos cartes et de leur historique. Rien n’en sort.',
  'stats.range': 'Période',
  'stats.range.4w': '4 semaines',
  'stats.range.3m': '3 mois',
  'stats.range.all': 'Tout',
  'stats.empty': 'Rien à compter pour l’instant. L’historique commence avec cette version et grandit à l’usage.',
  'stats.dread': 'La crainte ment-elle ?',
  'stats.timeToDone': 'Délai jusqu’à Terminé, par colonne',
  'stats.timeToDoneHint': 'Jours entre la création et Terminé, selon la colonne d’où la carte a été terminée.',
  'stats.done': 'Terminées',
  'stats.created': 'Créées',
  'stats.open': 'Ouvertes',
  'stats.median': 'Médiane',
  'stats.p75': '3 sur 4',
  'stats.dreadedRight': 'Redoutées, terminées plus à droite',
  'stats.dreadedRightHint': 'Cartes nées dans Redoutée et terminées une fois déplacées.',
  'stats.moves': 'Déplacements sur l’axe',
  'stats.movesHint': 'Vers Envie et vers Redoutée ; annuler ne compte pas.',
  'stats.forecast': 'Plus facile que craint',
  'stats.forecastHint': 'Vos réponses après Terminé sur une carte redoutée.',
  'stats.ofN': 'sur {n}',
  'stats.lever': 'Les dix minutes marchent-elles ?',
  'stats.attempts': 'Tentatives',
  'stats.attemptsHint': 'Séances de dix minutes.',
  'stats.ranStopped': 'au bout · arrêtées avant',
  'stats.feel': 'Ressenti après coup',
  'stats.feelHint': 'Vos réponses à la question après les dix minutes.',
  'stats.followed': 'Suivies d’un progrès',
  'stats.followedHint': 'Tentatives suivies dans la semaine d’un Terminé ou d’un pas vers Envie.',
  'stats.momentOpened': 'Offres à haute énergie ouvertes',
  'stats.momentOpenedHint': 'La carte redoutée proposée quand votre énergie est Haute.',
  'stats.momentSub': '{opened} sur {shown} ouvertes · {done} terminées dans la journée',
  'stats.morningDone': 'Choix du matin terminé le jour même',
  'stats.morningDoneHint': 'La chose redoutée choisie au point du matin.',
  'stats.dreadReasons': 'Crainte, par raison',
  'stats.dreadReasonsHint': 'Cartes selon la dernière raison nommée, et combien ont avancé ou été terminées ensuite.',
  'stats.cards': 'Cartes',
  'stats.movedOn': 'Ont avancé',
  'stats.when': 'Quand, et avec quelle énergie ?',
  'stats.byWeekday': 'Terminé par jour de la semaine',
  'stats.byHour': 'Terminé par moment de la journée',
  'stats.byHourHint': 'Tranches de quatre heures, à partir de minuit.',
  'stats.energyAtDone': 'Votre énergie au moment de le faire',
  'stats.energyAtDoneHint': 'Comparée à l’énergie demandée par la carte.',
  'stats.below': 'En dessous',
  'stats.atOrAbove': 'Assez',
  'stats.energyByHour': 'Énergie réglée, par moment de la journée',
  'stats.energyByHourHint': 'Chaque réglage de la batterie en haut de l’écran.',
  'stats.keepingUp': 'Est-ce que je tiens le rythme ?',
  'stats.perWeek': 'Terminées et créées par semaine',
  'stats.perWeekHint': 'Les semaines commencent le lundi.',
  'stats.openAge': 'Cartes ouvertes par ancienneté',
  'stats.openAgeHint': 'Depuis combien de temps les cartes ouvertes attendent.',
  'stats.age.week': 'Moins d’une semaine',
  'stats.age.month': '1 à 4 semaines',
  'stats.age.quarter': '1 à 3 mois',
  'stats.age.older': 'Plus ancien',
  'stats.late': 'Terminées en retard',
  'stats.lateHint': 'Parmi les cartes qui avaient une échéance.',
  'stats.recurring': 'Récurrentes, à l’heure',
  'stats.recurringHint': 'Occurrences terminées avant leur date.',
  'stats.ongoing': 'Continues, dans le rythme',
  'stats.ongoingHint': 'Intervalles entre deux fois restés dans le rythme.',
  'stats.timeToDoneBand': 'Délai jusqu’à Terminé, par bande',
  'stats.timeToDoneBandHint': 'Selon la bande d’importance d’où la carte a été terminée.',
  'stats.timeToDoneEnergy': 'Délai jusqu’à Terminé, par énergie',
  'stats.timeToDoneEnergyHint': 'Selon l’énergie demandée par la carte.',
  'stats.deleted': 'Jetées plutôt que terminées',
  'stats.deletedHint': 'Cartes supprimées face aux Terminé de la période ; une carte restaurée ne compte pas.',
  'stats.deletedSub': '{deleted} supprimées · {done} terminées',
  'stats.trend': 'Face à la période précédente',
  'stats.trendHint': 'Ces {period} à côté des {period} d’avant.',
  'stats.now': 'Maintenant',
  'stats.before': 'Avant',
  'stats.deletedRow': 'Supprimées',
  'stats.movesRightRow': 'Pas vers Envie',
  'lists.tabs': 'Listes',
  'review.hint': 'Un coup d’œil hebdomadaire à ce qui mérite une décision : en retard, important mais sans envie, ou oublié.',
  'review.overdue': 'En retard',
  'review.stuck': 'Important, sans envie',
  'review.stale': 'Sans changement depuis deux semaines',
  'review.empty': 'Rien à revoir. Bonne semaine.',
  'review.added': 'Ajoutée {when}',
  'review.touched': 'Dernier changement {when}',
  'deleted.title': 'Supprimées récemment',
  'deleted.hint': 'Restaurables pendant {n} jours après la suppression, depuis n’importe quel appareil.',
  'deleted.empty': 'Rien de supprimé récemment.',
  'toast.movedTo': 'Déplacée vers {column}',
  'toast.deleted': 'Carte supprimée',
  'toast.done': 'Terminé : {title}',
  'toast.undo': 'Annuler',
  'toast.doneForecast': 'Terminé : {title}. Par rapport à la crainte, c’était…',
  'forecast.easier': 'Plus facile',
  'forecast.worse': 'Pire',
  'tour.title': 'Visite du tableau',
  'tour.progress': 'Étape {n} sur {total}',
  'tour.next': 'Suivant',
  'tour.back': 'Retour',
  'tour.skip': 'Passer la visite',
  'tour.remove': 'Retirer les cartes d’exemple',
  'tour.keep': 'Les garder',
  'tour.step.columns': 'Les colonnes disent à quel point vous avez envie : Redouté à gauche, Neutre au milieu, Impatient à droite. Déplacez une carte en la faisant glisser, ou sur le téléphone en la balayant sur le côté.',
  'tour.step.bands': 'Chaque colonne a trois bandes : Doit, Devrait et Pourrait. Faites glisser une carte vers le haut ou le bas pour l’ordonner ; sur le téléphone, maintenez sa poignée.',
  'tour.step.energy': 'La batterie d’une carte est l’énergie qu’elle demande : un, deux ou trois segments. Touchez-la pour changer. Essayez sur cet exemple.',
  'tour.step.battery': 'C’est votre énergie du moment. Touchez-la pour choisir un niveau ; les cartes qui en demandent plus s’estompent sans disparaître. Elle s’efface d’elle-même après six heures.',
  'tour.step.add': 'Chaque bande a son propre + : la nouvelle carte commence dans cette colonne et cette bande. Un titre suffit ; ouvrez la carte plus tard pour le reste.',
  'tour.step.finish': 'C’est tout. Les trois cartes d’exemple peuvent partir maintenant, ou rester pour vous entraîner.',
  'tour.example.1': 'Appeler le dentiste',
  'tour.example.2': 'Préparer la randonnée du week-end',
  'tour.example.3': 'Trier le dossier photos',
  'tour.exampleNote': 'Une carte d’exemple de la visite.',
  'tour.exampleStep': 'Retrouver le numéro de téléphone',
  'settings.tour': 'Visite du tableau',
  'settings.tourStart': 'La revoir',
  'settings.title': 'Réglages',
  'settings.board': 'Tableau',
  'settings.bandPreset': 'Bandes',
  'settings.bandPreset.importance': 'Importance',
  'settings.bandPreset.horizon': 'Horizon',
  'settings.bandPresetHint': 'Importance : Doit, Devrait, Pourrait, rangés à la main. Horizon : Aujourd’hui, Cette semaine, Un jour, rangés par échéance ; déplacer une carte fixe sa date.',
  'settings.columnNames': 'Noms des colonnes',
  'settings.columns': 'Colonnes',
  'settings.columnsHint': 'De deux à six, de la moins envie à gauche à la plus envie à droite. Les cartes gardent leur place sur la nouvelle échelle.',
  'settings.fewerColumns': 'Une colonne de moins',
  'settings.moreColumns': 'Une colonne de plus',
  'settings.bandNames': 'Noms des bandes',
  'settings.resetLabels': 'Reprendre les noms par défaut',
  'settings.preferences': 'Préférences',
  'settings.language': 'Langue',
  'settings.language.auto': 'Automatique',
  'settings.timeFormat': 'Format de l’heure',
  'settings.timeFormat.auto': 'Automatique',
  'settings.timeFormat.12h': '12 heures',
  'settings.timeFormat.24h': '24 heures',
  'admin.defaultLocale': 'Langue par défaut',
  'admin.defaultTimeFormat': 'Format de l’heure par défaut',
  'admin.defaultsHint': 'Pour les utilisateurs dont la préférence est sur Automatique.',
  'settings.theme': 'Thème',
  'settings.theme.system': 'Système',
  'settings.theme.light': 'Clair',
  'settings.theme.dark': 'Sombre',
  'settings.accent': 'Couleur d’accent',
  'accent.teal': 'Sarcelle',
  'accent.blue': 'Bleu',
  'accent.indigo': 'Indigo',
  'accent.violet': 'Violet',
  'accent.plum': 'Prune',
  'accent.rose': 'Rose',
  'accent.slate': 'Ardoise',
  'install.title': 'Installer comme application',
  'install.hint': 'Sa propre fenêtre et une icône dans votre lanceur ; notifications comprises.',
  'install.button': 'Installer',
  'install.installed': 'Vous êtes dans l’application installée.',
  'install.manual': 'Utilisez l’option Installer de votre navigateur, dans son menu ou sa barre d’adresse. Firefox demande l’extension « Progressive Web Apps for Firefox ».',
  'push.title': 'Notifications dans ce navigateur',
  'push.hint': 'Les rappels et le point quotidien, livrés par le navigateur même quand hmawiw est fermé.',
  'push.unsupported': 'Ce navigateur ne peut pas recevoir de notifications de sites web.',
  'push.denied': 'Les notifications sont bloquées pour ce site dans les réglages du navigateur.',
  'push.error': 'Impossible d’activer les notifications : {message}',
  'push.testTitle': 'Vérifier qu’elles arrivent',
  'push.test': 'Envoyer une notification de test',
  'push.testSent': 'Envoyée. Elle devrait apparaître dans quelques secondes.',
  'push.testFailed': 'Le service de push l’a refusée. Désactivez puis réactivez les notifications.',
  'settings.checkin': 'Point quotidien',
  'settings.checkinHint': 'Demande votre énergie chaque jour à cette heure, sur le téléphone et dans les navigateurs où les notifications sont activées.',
  'settings.checkinOff': 'Désactivé',
  'notif.todayChannel': 'Aujourd’hui',
  'notif.todayChannelHint': 'Vos cartes du jour, gardées dans le volet',
  'notif.todayDone': 'Terminé',
  'settings.todayShade': 'Aujourd’hui dans le volet des notifications',
  'settings.todayShadeHint': 'Une notification discrète par carte en retard, échue aujourd’hui ou Doit, sur tous vos tableaux, avec un bouton Terminé. Tenue à jour quand l’app tourne, et environ tous les quarts d’heure quand elle est fermée.',
  'settings.on': 'Activé',
  'settings.off': 'Désactivé',
  'settings.about': 'À propos',
  'settings.version': 'Version {version}',
  'settings.build': 'Build',
  'settings.storage': '{n} cartes sur cet appareil',
  'settings.apk': 'Télécharger l’application Android',
  'settings.apkHint': 'Version {version} ({code}) · {build} · {size} Mo',
  'settings.apkUpdate': 'Mettre à jour l’application Android',
  'settings.apkCurrent': 'Application Android à jour',
  'settings.versionCode': 'Version {version} ({code})',
  'settings.noApk': 'Aucune version Android n’est disponible pour l’instant.',
  'account.title': 'Compte',
  'account.signedInAs': 'Connecté en tant que {username}',
  'account.changePassword': 'Changer le mot de passe',
  'account.email': 'Adresse e-mail',
  'account.emailHint': 'Où part le lien de réinitialisation du mot de passe. Rien d’autre.',
  'account.emailPlaceholder': 'vous@exemple.org',
  'account.emailInvalid': 'Ce n’est pas une adresse e-mail.',
  'account.signOut': 'Se déconnecter sur cet appareil',
  'account.signOutPending': '{n} modifications ne sont pas encore synchronisées. Se déconnecter quand même ?',
  'account.confirm': 'Se déconnecter',
  'devices.title': 'Appareils',
  'devices.thisDevice': 'Cet appareil',
  'devices.lastSeen': 'Vu {when}',
  'devices.revoke': 'Déconnecter',
  'devices.unavailable': 'Les appareils s’affichent quand le serveur est joignable.',
  'sync.idle': 'Synchronisé',
  'sync.syncing': 'Synchronisation',
  'sync.offline': 'Hors ligne',
  'sync.offlinePending': 'Hors ligne, {n} modifications en attente',
  'sync.error': 'Synchronisation en échec, nouvel essai',
  'sync.signedOut': 'Non connecté',
  'sync.now': 'Synchroniser maintenant',
  'sync.live': 'Synchronisé, en direct',
  'update.web': 'Une nouvelle version est prête : {current} → {next}.',
  'update.reload': 'Recharger',
  'update.apk': 'Mise à jour Android : {current} → {version} ({code}).',
  'update.get': 'Mettre à jour',
  'update.dismiss': 'Plus tard',
  'update.downloading': 'Téléchargement de la mise à jour, {pct} %',
  'update.installing': 'Ouverture de l’installateur.',
  'update.downloaded': 'La mise à jour est téléchargée.',
  'update.install': 'Installer',
  'update.allowInstall': 'Autorisez hmawiw à installer des applications sur l’écran qui s’est ouvert, puis touchez Mettre à jour.',
  'update.failed': 'Le téléchargement a échoué. Touchez Mettre à jour pour réessayer.',
  'auth.username': 'Nom d’utilisateur',
  'auth.password': 'Mot de passe',
  'auth.device': 'Cet appareil',
  'auth.deviceHint': 'Un nom que vous reconnaîtrez dans la liste des appareils, comme « Pixel 8 » ou « PC du bureau ».',
  'auth.signIn': 'Se connecter',
  'auth.working': 'Un instant',
  'auth.setupTitle': 'Créer le compte administrateur',
  'auth.setupHint': 'Ce serveur n’a encore aucun compte. Le premier est l’administrateur.',
  'auth.create': 'Créer le compte',
  'auth.registerTitle': 'Créer votre compte',
  'auth.inviteHint': 'Vous avez été invité sur ce tableau.',
  'auth.registerLink': 'Créer un compte',
  'auth.registerClosed': 'Vous avez un lien d’invitation ? Ouvrez-le pour créer votre compte.',
  'forgot.link': 'Mot de passe oublié ?',
  'forgot.title': 'Réinitialiser votre mot de passe',
  'forgot.hint': 'Si le compte a une adresse e-mail, un lien pour choisir un nouveau mot de passe y sera envoyé.',
  'forgot.send': 'Envoyer le lien',
  'forgot.sent': 'Si ce compte a une adresse e-mail, un message est en route. Le lien vaut une heure.',
  'forgot.back': 'Retour à la connexion',
  'reset.title': 'Choisir un nouveau mot de passe',
  'reset.done': 'Mot de passe changé. Connectez-vous avec.',
  'reset.invalid': 'Ce lien n’est plus valable. Demandez-en un nouveau.',
  'auth.haveAccount': 'Déjà un compte ? Se connecter',
  'auth.serverOffline': 'Le serveur est injoignable pour le moment.',
  'auth.error.BAD_CREDENTIALS': 'Nom d’utilisateur ou mot de passe incorrect.',
  'auth.error.RATE_LIMITED': 'Trop de tentatives. Patientez quelques minutes.',
  'auth.error.DISABLED': 'Ce compte est désactivé.',
  'auth.error.USERNAME_TAKEN': 'Ce nom d’utilisateur est déjà pris.',
  'auth.error.INVITE_INVALID': 'Ce lien d’invitation n’est plus valide.',
  'auth.error.REGISTRATION_CLOSED': 'Les inscriptions sont fermées. Demandez un lien d’invitation.',
  'auth.error.ALREADY_SETUP': 'Ce serveur a déjà un administrateur. Connectez-vous.',
  'auth.error.VALIDATION': 'Nom d’utilisateur : 3 à 32 caractères, minuscules, chiffres, point, tiret ou souligné. Mot de passe : 10 caractères ou plus.',
  'auth.error.generic': 'Quelque chose s’est mal passé. Réessayez.',
  'password.title': 'Choisir un nouveau mot de passe',
  'password.forced': 'Votre mot de passe a été défini par un administrateur. Choisissez le vôtre pour continuer.',
  'password.current': 'Mot de passe actuel',
  'password.next': 'Nouveau mot de passe',
  'password.confirm': 'Confirmer le nouveau mot de passe',
  'password.mismatch': 'Les deux mots de passe diffèrent.',
  'password.save': 'Enregistrer le nouveau mot de passe',
  'password.saved': 'Mot de passe changé. Vos autres appareils ont été déconnectés.',
  'admin.title': 'Admin',
  'admin.users': 'Utilisateurs',
  'admin.invites': 'Liens d’invitation',
  'admin.settings': 'Paramètres',
  'admin.cardsNote': 'Les cartes ne sont jamais listées ici. Les admins gèrent les comptes, pas les tableaux.',
  'admin.newUser': 'Créer un utilisateur',
  'admin.role': 'Rôle',
  'admin.role.admin': 'admin',
  'admin.role.user': 'utilisateur',
  'admin.tempPassword': 'Mot de passe temporaire',
  'admin.tempPasswordHint': 'Laissez vide pour en générer un. Il devra être changé à la première connexion.',
  'admin.tempPasswordShown': 'Mot de passe temporaire pour {username} : {password}. Il n’est affiché qu’une fois.',
  'admin.create': 'Créer l’utilisateur',
  'admin.resetPassword': 'Réinitialiser le mot de passe',
  'admin.makeAdmin': 'Rendre admin',
  'admin.makeUser': 'Rendre utilisateur',
  'admin.disable': 'Désactiver',
  'admin.enable': 'Réactiver',
  'admin.status.active': 'actif',
  'admin.status.disabled': 'désactivé',
  'admin.status.mustChange': 'doit changer de mot de passe',
  'admin.created': 'Créé',
  'admin.lastSignIn': 'Dernière connexion',
  'admin.never': 'jamais',
  'admin.devices': 'Appareils',
  'admin.you': 'vous',
  'admin.newInvite': 'Nouveau lien',
  'admin.inviteValid': 'valable {n} jours',
  'admin.copy': 'Copier le lien',
  'admin.copied': 'Lien copié',
  'admin.revoke': 'Révoquer',
  'admin.inviteUsed': 'Utilisé par {name}',
  'admin.inviteExpires': 'Expire {when}',
  'admin.inviteRevoked': 'Révoqué',
  'admin.inviteExpired': 'Expiré',
  'admin.inviteNew': 'Nouveau lien, copiez-le maintenant : {url}',
  'admin.noInvites': 'Aucun lien d’invitation pour l’instant.',
  'admin.appTitle': 'Titre de l’application',
  'admin.registration': 'Qui peut créer un compte',
  'admin.registration.closed': 'L’admin et les liens d’invitation seulement',
  'admin.registration.open': 'Toute personne ayant l’adresse',
  'admin.inviteExpiry': 'Les liens d’invitation restent valables',
  'admin.tombstone': 'Conserver les cartes supprimées',
  'admin.days': 'jours',
  'admin.tombstoneHint': 'Permet aux appareils hors ligne d’apprendre la suppression.',
  'admin.defaultColumns': 'Noms des colonnes pour les nouveaux comptes',
  'admin.defaultBands': 'Noms des bandes pour les nouveaux comptes',
  'admin.apk': 'Proposer l’application Android au téléchargement',
  'admin.save': 'Enregistrer les paramètres',
  'admin.saved': 'Paramètres enregistrés',
  'admin.stats': 'Chiffres',
  'admin.stats.users': 'Comptes',
  'admin.stats.cards': 'Cartes ouvertes, tous comptes',
  'admin.stats.db': 'Base de données',
  'admin.stats.purge': 'Dernière purge',
  'admin.stats.version': 'Version',
  'admin.error': 'Ça n’a pas fonctionné : {message}',
  'server.title': 'Quel serveur ?',
  'server.hint': 'Ce téléphone a besoin de l’adresse de votre serveur hmawiw.',
  'server.label': 'Adresse du serveur',
  'server.check': 'Se connecter',
  'server.unreachable': 'Aucun serveur hmawiw ne répond à cette adresse.',
  'server.current': 'Serveur : {url}',
  'server.change': 'Changer',
  'common.loading': 'Chargement',
  'common.cancel': 'Annuler',
};
